import React from 'react'

const Languages = () => {
  return (
    <div className="sklls__content">
        <h3 className="skills__titlle">Languages</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">Python</h3>
                    <span className="skills__level">Intermediate</span>
                </div>

                </div>

                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">C/C++</h3>
                    <span className="skills__level">Intermediate</span>
                </div>

                </div>

                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">Java</h3>
                    <span className="skills__level">Basic</span>
                </div>

                </div>
            </div>

            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">HTML</h3>
                    <span className="skills__level">Basics</span>
                </div>

                </div>

                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">CSS</h3>
                    <span className="skills__level">Basics</span>
                </div>

                </div>

                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">JavaScript</h3>
                    <span className="skills__level">Basic</span>
                </div>

                </div>
            </div>
        </div>
    </div>
  )
}

export default Languages
